<template>
  <g fill-rule="evenodd">
    <path
      d="M14.98 16.57a.8.8 0 00-1.13-1.14l-1.04 1.04V15.2c0-1.84-.8-3.59-2.18-4.8h5.85l-1.03 1.03a.8.8 0 001.13 1.14l2.4-2.4a.8.8 0 000-1.13l-2.4-2.4a.8.8 0 10-1.13 1.13l1.03 1.03h-5.85A6.38 6.38 0 0012.81 4V2.73l1.04 1.04a.8.8 0 101.13-1.14l-2.4-2.4a.8.8 0 00-1.13 0l-2.4 2.4a.8.8 0 101.13 1.14l1.03-1.04V4a4.8 4.8 0 01-4.8 4.8H6.3a3.2 3.2 0 100 1.6h.11a4.8 4.8 0 014.8 4.8v1.27l-1.03-1.04a.8.8 0 10-1.13 1.14l2.4 2.4a.8.8 0 001.13 0l2.4-2.4z"
    />
    <path d="M3.21 11.2a1.6 1.6 0 110-3.2 1.6 1.6 0 010 3.2z" class="secondary-color" />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ABTestsIcon",
});
</script>
